import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate , Link} from 'react-router-dom';
import { auth, db } from '../firebaseConfig.js'; // Importa auth y db desde firebaseConfig
import { doc, getDoc, updateDoc, setDoc, collection, addDoc } from 'firebase/firestore';

const SuccessPage = () => {
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState('');
  const [newBalance, setNewBalance] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchPaymentStatus = async () => {
      // Obtener el UID del usuario autenticado
      const user = auth.currentUser;
      if (!user) {
        setMessage("No se pudo verificar al usuario autenticado.");
        setLoading(false);
        return;
      }

      const userId = user.uid; // Obtener el UID del usuario autenticado

      // Obtener el monto real pagado desde los parámetros de la URL
      const amountPaid = new URLSearchParams(window.location.search).get('amount');
      if (!amountPaid) {
        setMessage('Monto no válido.');
        setLoading(false);
        return;
      }

      try {
        // Llamada a tu backend para procesar el pago y obtener el saldo actualizado
        const response = await axios.post('https://apimys.com/aprovado', { userId, amount: amountPaid });

        setMessage(response.data.message);

        // Obtener el documento del usuario en Firestore
        const userRef = doc(db, 'users', userId);
        const userDoc = await getDoc(userRef);

        if (userDoc.exists()) {
          const currentBalance = userDoc.data().saldo || 0;
          const updatedBalance = currentBalance + parseFloat(amountPaid);

          // Actualizar el saldo en la base de datos
          await updateDoc(userRef, {
            saldo: updatedBalance,
          });

          setNewBalance(updatedBalance);

          // Agregar el registro de la transacción en la colección "saldos"
          const saldosRef = collection(db, 'saldos');
          await addDoc(saldosRef, {
            userId,
            monto: parseFloat(amountPaid),
            estado: 'aprobado', // Estado de la transacción
            timestamp: new Date(), // Timestamp de la carga
          });

        } else {
          // Si el usuario no existe, lo creamos
          await setDoc(userRef, {
            saldo: parseFloat(amountPaid),
          });
          setNewBalance(parseFloat(amountPaid));

          // Agregar el registro de la transacción en la colección "saldos"
          const saldosRef = collection(db, 'saldos');
          await addDoc(saldosRef, {
            userId,
            monto: parseFloat(amountPaid),
            estado: 'aprobado',
            timestamp: new Date(),
          });
        }
      } catch (error) {
        setMessage('Error al procesar el pago.');
        console.error(error);
      } finally {
        setLoading(false);
      }
    };

    fetchPaymentStatus();
  }, []);

  if (loading) {
    return <div>Cargando...</div>;
  }

  return (
    <div style={{ textAlign: 'center' }}>
      <h1 style={{ color: 'green' }}>¡Pago Aprobado!</h1>
      <p>{message}</p>
      {newBalance !== null && <p>Tu nuevo saldo es: {newBalance} créditos.</p>}

       <Link to="/" className="button">Volver al Inicio</Link>
    </div>
  );
};

export default SuccessPage;
